import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP9BudgetCappedNew202606: FaireAdPerformancePeriodEntity = {
  token: "perf_p9_budget_capped_new_202606",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-06-01",
  endDate: "2026-06-30",
  impressions: 54402,
  clicks: 1129,
  adsSpendDollars: 4000,
  budgetDollars: 4000,
  salesDollars: 17828,
  bestEstimateRoas: 4.46,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 1,
  newCustomersAcquired: 66,
  dataAvailableAtDate: "2026-07-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
